import { DatePipe, TitleCasePipe, CommonModule } from '@angular/common';
import { Component, input, output, computed, signal, inject, ChangeDetectionStrategy } from '@angular/core';
import { NameMustMatchDirective, valuesMatch } from 'src/app/shared/name-must-match.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BlockCopyPasteDirective } from 'src/app/shared/block-copy-paste.directive';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';

interface AckDialogData {
  name: string;
  declarationDate: Date;
}

@Component({
  selector: 'ad-uk-statement-of-responsibilities-ack-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">ACKNOWLEDGMENT</h4>
    </div>
    <div class="modal-body">
      <p>Acknowledgement and Confirmation by the Employee</p>
      <div class="mb-3">
        <label class="form-label">Please input your full name</label>
        <ejs-textbox
          placeholder="Please input your full name"
          [ngModel]="name()"
          (ngModelChange)="name.set($event)"
          [htmlAttributes]="{ autocomplete: 'new-password' }"
          adBlockCopyPaste
          [adNameMustMatch]="nameToMatch()"
        ></ejs-textbox>
        <small class="form-text text-muted"
          >Must match your full name in the corporate directory ({{ nameToMatch() }})</small
        >
      </div>
      <p class="mt-3">
        <strong>{{ data().declarationDate | date }}</strong>
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="handleClose()" [disabled]="submitDisabled()">SUBMIT</button>
    </div>
  `,
  providers: [TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BlockCopyPasteDirective,
    CommonModule,
    DatePipe,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    TextBoxModule,
    NameMustMatchDirective
  ]
})
export class UkStatementOfResponsibilitiesAckDialogComponent {
  private titleCasePipe = inject(TitleCasePipe);

  public data = input.required<AckDialogData>();
  public closeDialog = output<AckDialogData>();

  protected name = signal<string | null>(null);
  protected nameToMatch = computed(() => this.data().name);
  protected submitDisabled = computed(() => !valuesMatch(this.name(), this.nameToMatch()));

  public handleClose() {
    this.closeDialog.emit({
      ...this.data(),
      name: this.titleCasePipe.transform(this.name()) || ''
    });
  }
}
